/**
 * Development environment configuration.
 * URLs mirror the AngularJS constants.js "development" environment block,
 * which is activated by envServiceProvider.set("development").
 */
export const environment = {
  production: false,

  // ── Authentication (auth-service) ──────────────────────────────
  authenticationServer: 'https://retailcalculusdemo.com/auth-service',

  // ── Item / Product data ────────────────────────────────────────
  itemRetailService: 'https://retailcalculusdemo.com/item-service',

  // ── UDD (User-Defined Data) ────────────────────────────────────
  uddService: 'https://retailcalculusdemo.com/udd-service',

  // ── Location data ──────────────────────────────────────────────
  locationService: 'https://retailcalculusdemo.com/location-service',

  // ── Vendor data ────────────────────────────────────────────────
  vendorService: 'https://retailcalculusdemo.com/vendor-service',

  // ── Entity / copyright / reference data ───────────────────────
  entityService: 'https://retailcalculusdemo.com/entity-service',

  // ── Cloud Cart ─────────────────────────────────────────────────
  cloudService: 'https://retailcalculusdemo.com/cloudcart-service',

  // ── MTO (Make To Order) ────────────────────────────────────────
  mtoService: 'https://retailcalculusdemo.com/mto-service',

  // ── Offers ─────────────────────────────────────────────────────
  offersService: 'https://retailcalculusdemo.com/:3052',

  // ── Events ─────────────────────────────────────────────────────
  eventsService: 'https://retailcalculusdemo.com/:3053',

  // ── Jobs ───────────────────────────────────────────────────────
  jobsService: 'https://retailcalculusdemo.com/jobs-service',

  // ── Order Advisor ──────────────────────────────────────────────
  orderadvisorService: 'https://retailcalculusdemo.com/orderadviser-service',

  // ── Storage / Search ───────────────────────────────────────────
  storageService: 'https://retailcalculusdemo.com/:6001',
  searchService:  'https://retailcalculusdemo.com/item-service',

  // ── Module ID (Product Explorer = 2) ──────────────────────────
  moduleId: '7'
};
